<template>
  <div class="playerAgeRadar" ref="playerAgeRadar">
    <div class="themeData">
      <div
        class="echart_dom"
        ref="echartDom_home"
        :style="{ height: `${pHeight}px` }"
      ></div>
    </div>
  </div>
</template>

<script>
// 年龄分布 主题
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'playerAgeRadar',
  mixins: [canvasToImage_base64_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        title: '',
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      echartsArr: [],
      pHeight: 0,
    }
  },
  watch: {
    datas(val) {
      setTimeout(() => {
        this.initChart(this.$refs.echartDom_home, this.isAutoExportPng)
      }, 10)
    },
  },
  created() {
    this.radarColor = ['rgba(255, 183, 101, 1)', 'rgba(53, 192, 213, 1)']
    console.debug(this.datas)
  },
  mounted() {
    this.$nextTick(() => {
      this.initDomWH()
      setTimeout(() => {
        this.initChart(this.$refs.echartDom_home, this.isAutoExportPng)
      }, 10)
    })
  },
  beforeDestroy() {
    //性能优化，防止溢出
    if (this.myEChart) {
      this.myEChart.dispose() //销毁echarts实例，防止内侧泄露
    }
    this.echartsArr = []
  },
  methods: {
    initDomWH() {
      const echartsBoxDom = this.$refs.playerAgeRadar
      console.debug('playerAgeRadar:', echartsBoxDom.clientWidth)
      this.pWidth = echartsBoxDom.clientWidth

      this.pHeight = echartsBoxDom.clientHeight
      console.debug('this.pWidth:', this.pWidth, this.pHeight)
    },
    initChart(echartRef, isAutoExportPng) {
      const name = 'playerAgeRadar'
      let result = this.echartsArr.some((val) => {
        if (val.name === name) {
          return true
        }
      })

      console.debug('result', result)

      if (!result) {
        let Echart = this.$echarts.init(echartRef)
        this.echartsArr.push({
          name: name,
          refs: echartRef,
          echarts: Echart,
        })
        setTimeout(() => {
          Echart.resize()
          // Echart.on('finished', (_) => {
          //   console.debug(113, 'finished')
          // })
          Echart.on('legendselectchanged', (val) => {
            console.debug('legendselectchanged', val)
            this.changeChartData(name, val)
          })
        }, 0)
      }
      this.changeChartData(name)
      //   console.debug('emitEventName:', isAutoExportPng)
      //   if (isAutoExportPng) {
      //     setTimeout(() => {
      //       this.upLoad(echartRef, true, 'uploadData')
      //     }, 500)
      //   }
    },
    changeChartData(echartName, itemType) {
      // const objectInfo = this.datas.objectInfo
      const keyArr = this.datas.statisticsModels
      const dataList = this.datas.data.dataList
      let maxList = this.datas.data.maxList ? this.datas.data.maxList : {}

      let radarNameArr = []

      let showTipItem = {}

      const seriesData = dataList.map((item, index) => {
        radarNameArr.push(item.projectCode ? item.projectCode : '')
        const value = keyArr.map((key, kIndex) => {
          let val = item[key['statisticalEn']] ? item[key['statisticalEn']] : 0
          console.debug(key, item, item[key['statisticalEn']], val)
          if (!maxList[key['statisticalEn']]) {
            maxList[key['statisticalEn']] = 0
          }
          maxList[key['statisticalEn']] += val - 0
          if (itemType) {
            if (itemType.selected[item.projectCode]) {
              if (!showTipItem[key['statisticalEn']]) {
                showTipItem[key['statisticalEn']] = 0
              }
              showTipItem[key['statisticalEn']] += val - 0
            }
          } else {
            showTipItem = maxList
          }
          return val
        })
        return {
          value,
          name: radarNameArr[index],
        }
      })

      console.debug('keyArr:', keyArr, dataList, maxList)
      let maxVal = 0

      if (itemType) {
        let valItemInd = 0
        dataList.forEach((valItem) => {
          if (itemType.selected[valItem.projectCode]) {
            console.debug('valItemInd:', valItemInd)
            valItemInd++
            // （俩个都被选中|单个被选中）|| 初始化时2个都被选中
            keyArr.forEach((model) => {
              if (valItem[model.statisticalEn] > maxVal) {
                maxVal = valItem[model.statisticalEn]
              }
            })
          }
        })
        if (valItemInd === dataList.length) {
          maxVal = 0
        }
      }
      const indicator = keyArr.map((model) => {
        return {
          name: model.name,
          // min: 0,
          max: maxVal === 0 ? maxList[model.statisticalEn] : maxVal,
          // max: maxList[model.statisticalEn],
        }
      })

      let vw = (window.innerWidth || window.screen.availWidth || 1440) / 100

      console.debug('indicator:', radarNameArr, seriesData, indicator)
      let options = {
        title: {
          show: false,
          text: '年龄分布',
        },
        color: this.radarColor,
        legend: {
          show: true,
          data: radarNameArr,
          top: '5%',
        },
        tooltip: {
          show: false,
          valueFormatter: (value) => {
            console.debug('tooltip:', value)
            return `${value}`
          },
        },
        radar: {
          center: ['50%', '60%'],
          radius: '50%',
          indicator,
          axisName: {
            formatter: function (value, indicator) {
              console.debug('formatter:', value, indicator)
              let playerNum = ''
              // dataList.map((item, index) => {
              //   keyArr.forEach((key) => {
              //     if (value == key['name']) {
              //       playerNum = item[key['statisticalEn']]
              //         ? `${item[key['statisticalEn']]}人`
              //         : 0
              //     }
              //   })
              // })
              keyArr.forEach((key) => {
                if (value == key['name']) {
                  playerNum = showTipItem[key['statisticalEn']]
                    ? `${showTipItem[key['statisticalEn']]}人`
                    : 0
                }
              })

              if (value !== '18-25') {
                return [`{b|${value}}`, `{a|${playerNum}}`].join('\n')
              } else {
                return [`{a|${playerNum}}`, `{b|${value}}`].join('\n')
              }
            },
            rich: {
              a: {
                color: 'rgba(0,0,0,0.85)',
                lineHeight: Math.floor(1.667 * vw),
                fontSize: Math.floor(1.11 * vw),
              },
              b: {
                fontSize: Math.floor(0.833 * vw),
                backgroundColor: 'rgba(146, 189, 34, 1)',
                color: '#fff',
                borderRadius: Math.floor(0.694 * vw),
                lineHeight: Math.floor(0.972 * vw),
                padding: [0, Math.floor(0.347 * vw)],
                align: 'center',
              },
            },
          },
          axisLabel: {
            show: false,
          },
          // indicator: [
          //   { name: 'Sales', max: 6500 },
          //   { name: 'Administration', max: 16000 },
          //   { name: 'Information Technology', max: 30000 },
          //   { name: 'Customer Support', max: 38000 },
          //   { name: 'Development', max: 52000 },
          //   { name: 'Marketing', max: 25000 },
          // ],
        },
        series: [
          {
            name: `${radarNameArr[0]} vs ${radarNameArr[1]}`,
            type: 'radar',
            // itemStyle: {
            //   color: 'blue',  //控制雷达塔覆盖区域颜色
            // },
            areaStyle: {
              opacity: 0.1, //控制雷达塔覆盖区域颜色透明度
            },
            // label: {
            //   formatter: function(val) {

            //   }
            // },
            data: seriesData,

            // data: [
            //   {
            //     value: [4200, 3000, 20000, 35000, 50000, 18000],
            //     name: homeName,
            //   },
            //   {
            //     value: [5000, 14000, 28000, 26000, 42000, 21000],
            //     name: awayName,
            //   },
            // ],
          },
        ],
      }
      this.echartsArr.forEach((val, index) => {
        if (val.name === echartName) {
          console.debug('val.name:', val.name, 'name', echartName)
          val.echarts.setOption(options)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.playerAgeRadar {
  position: relative;
  width: 100%;
  height: 19.02vw;
  padding: 0 3%;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  .themeData {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    .echart_dom {
      width: 85%;
    }
  }
}
.mixtmt_ipad .playerAgeRadar {
  padding: 0 2%;
  .themeData {
    .echart_dom {
      width: 85%;
    }
  }
}
</style>
